import { useState } from 'react';

import InfoIconArtwork from '@/shared-components/icons/components/public/InfoIconArtwork';
import Text from '@/shared-components/text/components/Text';

import './styles/TextToggle.css';

/**
 * This component only allows to be used in a controlled state
 */
export default function TextToggle({ optionA, optionAText, optionB, optionBText, readOnly, value, onChange, headerInfoIcon='', infoIconDescription='', headerInfoIcon2='', infoIconDescription2='' }) {
  const [isInfoIconOpen, setIsInfoIconOpen] = useState(false);
  const selectedOption = value === optionB ? 'b' : 'a';

  function handleChange(option) {
    if(readOnly || value === option || typeof onChange !== 'function') return;

    onChange(option);
  }

  return (
    <>
      <div
        className={`text-toggle__container element-non-selectable${readOnly ? " read-only" : ""}`}
        data-selected-option={selectedOption}
      >
        <button
          type="button"
          className={`text-toggle__option${value === optionA ? " active" : ""}`}
          disabled={readOnly}
          aria-pressed={value === optionA}
          onClick={() => handleChange(optionA)}
        >
          <Text className="text-toggle__text">{optionAText || optionA}</Text>
        </button>

        <button
          type="button"
          className={`text-toggle__option${value === optionB ? " active" : ""}`}
          disabled={readOnly}
          aria-pressed={value === optionB}
          onClick={() => handleChange(optionB)}
        >
          <Text className="text-toggle__text">{optionBText || optionB}</Text>
        </button>
      </div>
      {infoIconDescription.length > 0 && 
          <InfoIconArtwork
            className="step-accordeon-step-header__info-icon"
            onClick={(status) => setIsInfoIconOpen(status)}
            open={isInfoIconOpen}
            header={headerInfoIcon}
            description={infoIconDescription}
            header2={headerInfoIcon2}
            description2={infoIconDescription2}
          />
      }
    </>
  );
}
